<template>
  <li class="toc-item">
    <a v-scroll-to="`#`+category_slug">{{c.name}}</a>
    <span v-if="show_buttons">  
      <button v-if="!show_descendants" class="btn btn-default btn-sm" @click="set_show_descendants(true)"><i class="fa fa-plus" aria-hidden="true"></i></button>
      <button v-else class="btn btn-default btn-sm" @click="set_show_descendants(false)"><i class="fa fa-minus" aria-hidden="true"></i></button>
    </span>
    <transition name="slide-fade" mode="in-out">
      <ul v-if="show_descendants">
        <TableOfContentsItem
          v-for="item in c.children"
          v-bind:c="item"
          v-bind:key="item.id">
        </TableOfContentsItem>
      </ul>
    </transition>
  </li>
</template>

<script>
import { helpers } from '../mixins/helpers'
import TableOfContentsItem from './TableOfContentsItem.vue'
export default {
  mixins: [helpers],
  components: {
    TableOfContentsItem
  },
  name: 'TableOfContentsItem',
  data () {
    return {
      show_descendants: false,
    }
  },
  props: {
    c: {
      type: Object,
      required: true
    }
  },
  methods: {
    set_show_descendants(show) {
      this.show_descendants = show;
    }
  },
  computed: {
    category_slug() {
      return this.to_slug(this.c.name);
    },
    show_buttons() {
      return this.c.children.length > 0;
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
li.toc-item {
  list-style-type: none;
  font-size: .8em;
  font-weight: 700;
  ul {
    padding: 0;
    margin: 0;
    font-size: .9em;
    @media(min-width: 768px) {
      font-size: .95em;
    }
    li {
      font-weight: 500;
      text-align: left;
      padding: 6px 0;
      list-style-type: square;
      @media(min-width: 768px) {
        padding: 0;
        margin-left: 17px;
      }
      ul {
        display: block;
        li {
          margin-left: 0;
          font-weight: 500;
          text-align: left;
          padding-left: 15px;
          list-style-type: square;
          list-style-position: inside;
          @media(min-width: 768px) {
            padding-left: 30px;
          }
          &:last-child {
            margin-bottom: 16px;
          }
          ul {
            li {
              padding-left: 30px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
  a {
    cursor: pointer;
    transition: transform .3s ease-out;
    color: #5f5f5f;
    -webkit-transition: all 180ms ease;
    -moz-transition: all 180ms ease;
    -ms-transition: all 180ms ease;
    -o-transition: all 180ms ease;
    transition: all 180ms ease;
    &:hover {
      color: darken(#5f5f5f,30%);
      font-weight: 700;
      cursor: pointer;
    }
  }
  .toc-item {
    font-size: 1em;
  }
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .35s ease;
}
.slide-fade-leave-active {
  transition: all .35s cubic-bezier(.2, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TableOfContents/TableOfContentsItem.vue